var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMemo } from 'react';
import { PROD_ADMIN_TOKEN, STAGE_ADMIN_TOKEN, STAGE_CENTRIFUGE_DOMAIN, PROD_CENTRIFUGE_DOMAIN, } from '../../../constants/common';
import { useEnvironment } from '../../../hooks';
export var useCentrifugeOptions = function (_a) {
    var _b = _a.stand, stand = _b === void 0 ? 'dev' : _b, options = __rest(_a, ["stand"]);
    var _c = useEnvironment(stand), isDev = _c.isDev, isProd = _c.isProd;
    var token = useMemo(function () {
        if (options.token)
            return options.token;
        return isDev ? STAGE_ADMIN_TOKEN : PROD_ADMIN_TOKEN;
    }, [options.token, isDev]);
    var domain = isDev ? STAGE_CENTRIFUGE_DOMAIN : PROD_CENTRIFUGE_DOMAIN;
    var url = options.url || "wss://".concat(domain, "/connection/websocket");
    return { url: url, token: token, stand: stand, domain: domain, isDev: isDev, isProd: isProd };
};
//# sourceMappingURL=useCentrifugeOptions.js.map